

import { defineComponent} from 'vue'
import { Logo } from '@/components/atoms'
import { NavBar, SearchForm } from '@/components/molecules'
export default defineComponent({
  components: { Logo, NavBar, SearchForm}
})
